import { AmmunitionStockEventRowsServiceBase } from './ammunition-stock-event-rows.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AmmunitionStockEvent } from 'assets-model';
import { Observable } from 'rxjs';


export abstract class AmmunitionStockEventRowsServiceCommon<G> extends AmmunitionStockEventRowsServiceBase<G> {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }
  // methods shared across subclasses for different group keys
}

@Injectable({
  providedIn: 'root'
})
export class AmmunitionStockEventRowsService extends AmmunitionStockEventRowsServiceCommon<any> {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findAllInGroup(key: any, pageSpec?: PageSpecification): Observable<HateoasMultipleResponseObject<AmmunitionStockEvent>> {
    return this.findByFullFilters(key, pageSpec);
  }
}



